// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactNavButton-cls1_DVJ","cls2":"ImpactNavButton-cls2_G_Q ImpactNavButton-cls1_DVJ"};